window.stores = [];
$(document).ready(function () {
  var manufacture_option = getCookie("sel_manufacture__option");
  if (manufacture_option) {
    setTimeout(function () {
      $(
        `.customizer-tab-wrapper .tab-heading[data-target="${manufacture_option}"]`
      ).click();
    }, 1000);
  }
  console.log(manufacture_option, "<< manufacture_option");

  // START: check radio levels js
  function checkRadioButtons() {
    if ($('.first-level-block input[name="brandInput"]:checked').length > 0) {
      $(".nextlevel").removeClass("disabled");
      var $_dataUrl = $('input[name="brandInput"]:checked').data("url");
      var $brand_name = $('input[name="brandInput"]:checked').data("value");

      if ($brand_name === "apple") {
        $(".nextpagelink").addClass("apple_brand_active");
        $(".nextlevel").addClass("apple_brand_active");
        $(".nextpagelink").attr("href", "javascript:void(0)");
      } else {
        $(".nextpagelink").attr("href", $_dataUrl);
        $(".nextpagelink").removeClass("apple_brand_active");
        $(".nextlevel").removeClass("apple_brand_active");
      }
    } else {
      $(".nextlevel").addClass("disabled");
    }
  }
  function checkDeviceName() {
    if ($('input[name="iphoneDeviceInput"]:checked').length > 0) {
      $(".nextlevel").removeClass("disabled");
      var $_dataUrl = $('input[name="iphoneDeviceInput"]:checked').data("url");
      $(".nextpagelink").attr("href", $_dataUrl);
    } else {
      $(".nextlevel").addClass("disabled");
    }
  }

  checkRadioButtons();
  checkDeviceName();
  // END: check radio levels js

  $(document).on("click", ".nextlevel.first-level-active", function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.addClass("second-level-active disabled");
    $this.removeClass("first-level-active");
    $this.removeClass("selected");

    $(".first-level-block").addClass("third-level-active");
    $(".backlevel").addClass("third-level-active");
    $(".progress-bar").addClass("third-level-active");

    // $(".first-level-block").addClass("second-level-active");
    // $(".backlevel").addClass("second-level-active");
    // $(".second-level-block").addClass("second-level-active");
    // $(".progress-bar").addClass("second-level-active");
    // $(".third-level-block").addClass("second-level-active");
  });

  // $(document).on("click", ".nextlevel.second-level-active", function (e) {
  //   if ($(this).hasClass("apple_brand_active")) {
  //     e.preventDefault();
  //     $(this).removeClass("second-level-active");
  //     $(".nextlevel").addClass("third-level-active");
  //     $(".button--wrapper").hide();
  //     $(".backlevel").removeClass("first-level-active");
  //     $(".backlevel").removeClass("second-level-active");
  //     $(".backlevel").addClass("third-level-active");
  //     $(".first-level-block").addClass("third-level-active");
  //     $(".third-level-block").addClass("third-level-active");
  //     $(".second-level-block").removeClass("second-level-active");
  //     $(".second-level-block").addClass("third-level-active");
  //     $(".progress-bar").addClass("third-level-active");
  //     $(".progress-bar").removeClass("second-level-active");
  //     $(".third-level-block").removeClass("second-level-active");
  //   }
  // });

  // $(document).on("click", ".backlevel.second-level-active", function () {
  //   $(this).removeClass("second-level-active");
  //   $(".backlevel").addClass("first-level-active");
  //   $(".backlevel").removeClass("third-level-active");
  //   $(".progress-bar").removeClass("second-level-active");
  //   $(".progress-bar").addClass("first-level-active");
  //   $(".first-level-block").addClass("first-level-active");
  //   $(".first-level-block").removeClass("second-level-active");
  //   $(".second-level-block").removeClass("second-level-active");
  //   $(".iphone-devices__name-wrap").removeClass("third-level-active");
  //   $(".nextlevel").addClass("first-level-active");
  //   $(".nextlevel").removeClass("second-level-active");
  //   $(".nextlevel").removeClass("third-level-active");
  // });

  $(document).on("click", ".backlevel.third-level-active", function () {
    $(".backlevel").removeClass("third-level-active");
    $(".backlevel").removeClass("first-level-active");
    $(".backlevel").addClass("second-level-active");
    $(".third-level-block").removeClass("third-level-active");
    $(".second-level-block").addClass("second-level-active");
    $(".progress-bar").removeClass("third-level-active");
    $(".progress-bar").addClass("second-level-active");
    $(".nextlevel").addClass("second-level-active");
    $(".nextlevel").removeClass("third-level-active");
    $(".second-level-block").removeClass("third-level-active");
  });

  // START: check radio levels js
  $(document).on("change", 'input[name="brandInput"]', function () {
    checkRadioButtons();
    var $this = $(this),
      $_closest = $this.closest(".js-brand-selector"),
      $_find = $_closest.find(".radio-input"),
      $_dataUrl = $_find.data("url"),
      $brand_name = $_find.data("value");
    $(".button--wrapper").hide();
    if ($('input[name="brandInput"]:checked').length > 0) {
      $(".nextlevel").addClass("selected");
      if ($brand_name === "apple") {
        $(".first-level-block").addClass("third-level-active");
        $(".nextpagelink").attr("href", "javascript:void(0)");
      }
    } else {
      $(".nextpagelink").attr("href", $_dataUrl);
      $(".nextlevel").addClass("disabled");
    }
  });

  $(document).on("click", ".js-brand-selector", function () {
    var $_this = $(this);
    setTimeout(function () {
      var $_closest = $_this.closest(".js-brand-selector"),
        $_find = $_closest.find(".radio-input"),
        h = $_find.attr("data-url") || $(".nextpagelink").attr("href"),
        $brand_name = $_find.data("value");
      console.log(h, '"<<<"', $_find.attr("data-url"));
      if (!h.length || h == "" || h == "#" || h == "javascript:void(0)") {
        //gotonextpage
         $('.third-level-block ').show();
         $('.first-level-block').hide();
        // alert("dgd");
        return;
      }
      // $(".nextpagelink").trigger("click");
      window.location.href = $(this).find(".radio-input").attr("data-url") || h;
      //  if ($brand_name === "apple") {
      //    $('.third-level-block').show();
      //    $('.first-level-block').hide();
      //    } else {
      // $(".nextpagelink").trigger("click");
      //  window.location.href = $(this).find(".radio-input").attr("data-url");
      //    }
    }, 10);
  });

  $(document).on("change", 'input[name="iphoneDeviceInput"]', function () {
    checkDeviceName();
    var $this = $(this),
      $_closest = $this.closest(".js-name-selector"),
      $_find = $_closest.find(".radio-input"),
      $_dataUrl = $_find.data("url");
    if ($('input[name="iphoneDeviceInput"]:checked').length > 0) {
      $(".nextpagelink").attr("href", $_dataUrl);
    } else {
      $(".nextlevel.first-level-active").addClass("disabled");
    }
  });
  // END: check radio levels js

  var sel_manufacture__options = [];
  $(document).on("change", ".manufacture__options", function () {
    var $el = $(this),
      val = $el.val(),
      target = $el.attr("data-target");
    if ($el.prop("checked")) {
      sel_manufacture__options.push(target);
    } else {
      sel_manufacture__options = sel_manufacture__options.filter(
        (item) => item !== target
      );
    }
    if ($(".manufacture__options:checked").length) {
      $(".nextlevel.second-level-active").removeClass("disabled");
    } else {
      $(".nextlevel.second-level-active").addClass("disabled");
    }

    setCookie(
      "sel_manufacture__option",
      sel_manufacture__options[0] || null,
      1
    );
    console.log(
      sel_manufacture__options,
      "<<<<< sel_manufacture__options",
      getCookie("sel_manufacture__option")
    );
  });

  $(document).on("click", ".selected-element", function () {
    var target = $(this).data("target"),
      fixedHeaderHeight = $(".header-wrapper").outerHeight(),
      maindiv = $(target).offset().top - fixedHeaderHeight - 30;
    $("html, body").animate(
      {
        scrollTop: maindiv,
      },
      1000
    );
  });

  // START:- macbook selection
  $(document).on("click", ".faq-heading-wrapp", function () {
    $(this).next(".faq-content-wrapp").slideToggle();
    $(this).toggleClass("active");
  });
  // END:- macbook selection

  // START:- customizer collection tab

  $(document).on("click", ".tab-heading", function (e) {
    e.preventDefault();
    var __this = $(this),
      currentAttrValue = __this.data("target"),
      __dataName = __this.data("name");
    console.log("__dataName<><><", __dataName);
    setCookie("Manufacture_Name", __dataName, 1);
    $(currentAttrValue).addClass("active").siblings().removeClass("active");
    $(this).addClass("active").siblings().removeClass("active");
  });

  $(document).on("click", ".slide-content .heading", function () {
    var $_this = $(this),
      $_closest = $_this.closest(".slide-content"),
      $_find = $_closest.find(".content");
    $_find.slideToggle();
    if ($_closest.hasClass("active")) {
      $_closest.removeClass("active");
      $_find.removeClass("active");
    } else {
      $_find.addClass("active");
      $_closest.addClass("active");
    }
  });

  // check div length and add class

  $(".tab").each(function () {
    var contentCount = $(this).find(".tab-allcontent-wrapp").length;
    if (contentCount === 1) {
      $(this)
        .find(".tab-allcontent-wrapp")
        .css("width", "100%")
        .addClass("tab-allcontent-wrappfull");
    } else if (contentCount === 2) {
      $(this)
        .find(".tab-allcontent-wrapp")
        .css("width", "50%")
        .addClass("tab-allcontent-wrapphalf");
    } else {
      $(this)
        .find(".tab-allcontent-wrapp")
        .css("width", "33%")
        .addClass("tab-allcontent-wrappthird");
    }
  });

  $(".main-tab-wrapp").each(function () {
    var contentCount = $(this).children().length;

    $(this).css("display", "flex");

    if (contentCount === 1) {
      $(this).children().css("width", "100%");
    } else if (contentCount === 2) {
      $(this).children().css("width", "50%");
    } else if (contentCount === 3) {
      $(this).children().css("width", "33.33%");
    }
  });
  // END:-  customizer collection tab

  //START:- custoizer collection visitUs popup

  /** START:- choose services when selected item**/
  $(document).on("click", ".choose-visit-services", function (e) {
    e.preventDefault();
    $(".email-wrapper").show();
    $(this).addClass("active-service");
    $(".choose-mail-services").removeClass("active-service");
  });
  $(document).on("click", ".choose-mail-services", function (e) {
    e.preventDefault();
    var main_product_price = $(this).attr("prod-price");
    $(".email-wrapper").hide();
    $(".visit-method--wrapper").hide();
    $(".delivery-method-wrapper").show();
    $(this).addClass("active-service");
    $(".choose-visit-services").removeClass("active-service");
    $(".booking-progress-wrap.second-step").addClass("active");
    $(".booking-progress-wrap.first-step").removeClass("active");
    $(".booking-progress-wrap.first-step").addClass("active-next-step");

    $(".mail-continue-button").attr("main-product-price",'£'+main_product_price);
  });
  /** END:- choose services when selected item**/

  $(document).on("click", ".pro-button-wrap", function (e) {
    e.preventDefault();
    ($_this = $(this)),
      ($_closest = $_this.closest(".product--wrapper")),
      ($find_img = $_closest.find(".product_image")),
      ($find_price = $_closest.find(".product-price")),
      (product_price = $find_price.attr("prod-price")),
      (prod_title = $_closest.find(".product-title")),
      (prod_id = $_this.children(".product-variant-id").val()),
      (prod_title_val = prod_title.attr("prod-title")),
      ($src = $find_img.attr("src"));

    $(".add-product-fields").attr("main-product-id", prod_id);

    $(".visitUs-popup-wrapper").show();
    $("body").addClass("active-popup");
    $(".bookingimage img").attr("src", $src);
    $(".product-title").text(prod_title_val);
    $(".repair-product-price").text("£" + product_price);
    $(".repair-type-image img").attr("src", $src);
    $(".choose-mail-services").attr("prod-price", '£' + product_price);
  });

  $(document).on("click", ".second-step.active .previous_link", function () {
    ($_this = $(this)),
      (closest = $_this.closest(".booking-progress-wrap.second-step"));
    closest.removeClass("active");
    $(".booking-progress-wrap.first-step").addClass("active");
    $(".booking-progress-wrap.first-step").removeClass("active-next-step");
    $(".delivery-method-wrapper").hide();
    $(".visit-method--wrapper").show();
    $(".store-locator-wrapper").hide();
  });

  $(document).on("click", ".third-step.active .previous_link", function () {
    $(".booking-calender-slot-wrapper").hide();
    $(".store-locator-wrapper").show();
    $(".third-step.active").removeClass("active");
    $(".booking-progress-wrap.second-step").removeClass("active-next-step");
    $(".booking-progress-wrap.second-step").addClass("active");
  });

  $(document).on("click", ".fourth-step.active .previous_link", function () {
    var $_this = $(this),
      closest = $_this.closest(".booking-progress-wrap.fourth-step");

    $_this.addClass("active-back-step");
    closest.removeClass("active");

    $(".booking-progress-wrap.fourth-step").removeClass("active store-service");
    $(".booking-progress-wrap.first-step").addClass("active");
    $(".booking-progress-wrap.first-step").removeClass("active-next-step");
    $(".booking-progress-wrap.second-step").removeClass("active-next-step");
    $(".booking-progress-wrap.third-step").removeClass("active-next-step");
    $(".form-wrapper").hide();
    $(".delivery-method-wrapper").hide();
    $(".visit-method--wrapper").show();
  });

  $(document).on("click", ".booking-progress-wrap.first-step .previous_link", function () {
    var $_this = $(this);

    if ($_this.hasClass("active-next-step")) {
      $_this.removeClass("active-next-step");
      $_this.addClass("active");
      $(".booking-progress-wrap.second-step").removeClass("active");
      $(".booking-progress-wrap.third-step").removeClass("active");
      $(".booking-progress-wrap.fourth-step").removeClass("active");
      $(".booking-progress-wrap.fifth-step").removeClass("active");
      $(".visit-method--wrapper").show();
      $(".delivery-method-wrapper").hide();
      $(".form-wrapper").hide();
    } else {
      $("body").removeClass("active-popup");
      $(".visitUs-popup-wrapper").hide();
    }
  });

  /** START:- code for add addon product on form **/
  $(document).on("click", ".choose-services", function () {
    var active_prod_wrap = $(".tab.active").find(".product--wrapper"),
      addon_prod_wrap = $(".mail-product-details"),
      addon_prod_image = addon_prod_wrap.attr("data-image"),
      addon_prod_price = addon_prod_wrap.attr("data-price"),
      __this = $(this),
      data_attr = __this.attr("store-type"),
      addon_prod_id = addon_prod_wrap.attr("data-id");
    $(".add-prod-input").attr("addon-prod-id", addon_prod_id);
    $(".mail_image").attr("src", addon_prod_image);
    setCookie("store_type", data_attr || null, 1);

    $(".mail-continue-button").attr("store-type", data_attr);
  });
  /** END:- code for add addon product on form **/

  /** START:- code for add cookies and enable fourth step **/
  $(document).on("click", ".mail-continue-button", function () {
    var now = new Date();
    var booking_date = now.toISOString().split("T")[0];
    var booking_time = now.toTimeString().split(" ")[0];
    var active_prod_wrap = $(".tab.active").find(".product--wrapper"),
      data_attr = getCookie("store_type");
    $(".booking-progress-wrap.fourth-step").addClass("active");
    $(".booking-progress-wrap.second-step").addClass("active-next-step");
    $(".booking-progress-wrap.third-step").addClass("active-next-step");
    $(".booking-progress-wrap.second-step").removeClass("active");
    $(".form-wrapper").show();
    $(".delivery-method-wrapper").hide();
    setCookie("store_type", data_attr || null, 1);
    setCookie("store_name", "Mobilebitz- Main Store", 1);
    setCookie("booking_time", booking_time || null, 1);
    setCookie("booking_date", booking_date || null, 1);
  });
  /** END:- code for add cookies and enable fourth step **/

  /** START:- form agrement input **/
  $(".js-appoint-button").addClass("disabled");
  $(document).on("change", ".termcontent", function () {
    aggrement();
  });
  aggrement();

  $(document).on("click", ".js-appoint-button", function (e) {
    e.preventDefault();
    var $_this = $(this),
      closest = $_this.closest(".js-add-product"),
      find = closest.find(".add-product-fields"),
      main_prod_id = find.attr("main-product-id"),
      additional_prod_id = find.attr("additional-product-id"),
      device_passcode = $(
        ".form-main-wrapper input[name='contact[device_passcode]']"
      ).val();
    if ($(".termcontent").is(":checked")) {
      $(".js-appoint-button").removeClass("disabled");
      $(".error-msg").hide();
      var term_accept = true;
    } else {
      $(".js-appoint-button").addClass("disabled");
      $(".error-msg").show();
      var term_accept = false;
    }
  });
  /**------------ END:- form agrement input --------------**/

  /**------------ START:- proceed to choose a store -----------**/

  $(".email-wrapper .btn_label").addClass("disabled");
  $(".customer-email-id").on("input", function () {
    var email = $(this).val();
    var isValidEmail = validateEmail(email);
    if (isValidEmail && email.trim() !== "") {
      $(".email-wrapper .btn_label").removeClass("disabled");
    } else {
      $(".email-wrapper .btn_label").addClass("disabled");
    }
  });

  $(document).on("click", ".email-wrapper .btn_label", function (e) {
    e.preventDefault();
    $(".store-locator-wrapper").show();
    $(".visit-method--wrapper").hide();
    $(".booking-progress-wrap.first-step").removeClass("active");
    $(".booking-progress-wrap.second-step").addClass("active");
    $(".booking-progress-wrap.first-step").addClass("active-next-step");
  });
  /**---------------- END:- proceed to choose a store -------------------**/

  /**----------------- END:- custoizer collection visitUs popup ---------------**/

  /**---------------------- START:- store locator map -----------**/
  var map;
  var markers = [];
  var userMarker;

  function initMap() {
    var defaultLatLng = { lat: 51.4536968, lng: -0.9707661 };
    map = new google.maps.Map(document.getElementById("map"), {
      center: defaultLatLng,
      zoom: 10,
    });
    if (userMarker) {
      userMarker.setMap(null);
    }
    userMarker = new google.maps.Marker({
      position: { lat: 51.4536968, lng: -0.9707661 },
      map: map,
      zoom: 12,
    });
  }

  //--------------- Add current location marker when the button is clicked ----------------//
  $(document).on("click", "#get-location-btn", function () {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          var pincode = getPincode(lat, lng);
          var origin = { lat: lat, lng: lng };

          map.setCenter({ lat: lat, lng: lng });

          if (userMarker) {
            userMarker.setMap(null);
          }
          userMarker = new google.maps.Marker({
            position: { lat: lat, lng: lng },
            map: map,
            zoom: 15,
          });

          console.log("User Latitude:", lat);
          console.log("User Longitude:", lng);
          console.log("Pincode:", pincode);

          fetchStores(pincode, origin);
        },
        function (error) {
          console.error("Geolocation error:", error);
          alert("Error getting location.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  });

  //-------------------- Initialize the map when the page is loaded --------------------///
  google.maps.event.addDomListener(window, "load", initMap);

  //---------------- Event listener for form submission------------------------------//
  $("#location-form").on("submit", function (e) {
    e.preventDefault();

    const pincode = $("#pincode").val();

    setCookie("customer_pincode", pincode || null, 1);

    $.get(
      "https://maps.googleapis.com/maps/api/geocode/json",
      {
        address: pincode,
        key: "AIzaSyBa2bxAi5-ZjZ30Pxp9PPl94Dgin8Sottw",
      },
      function (data) {
        if (data.status === "OK") {
          const latLng = data.results[0].geometry.location;
          const origin = { lat: latLng.lat, lng: latLng.lng };

          // Center the map
          map.setCenter(origin);
          map.setZoom(15);

          // Add marker for user location
          if (userMarker) {
            userMarker.setMap(null);
          }

          userMarker = new google.maps.Marker({
            position: origin,
            map: map,
          });

          // Fetch stores for the entered pincode
          fetchStores(pincode, origin);
        } else {
          console.error("Geocoding failed: " + data.status);
        }
      }
    );
  });

  /**--------------- END:- store locator map --------------------**/

  /**----------------- START:- fetch data related to pincode--------------------------------**/

  $(document).on("click", ".view-details-wrap", function () {
    $(this).next(".opening-addres-wrap").slideToggle();
    $(this).toggleClass("active");
  });

  $(document).on("click", ".select-btn-wrap", async function () {
    try {
      const $_this = $(this);
      const $closest = $_this.closest(".store-name-container");
      const store_name = $closest.find(".main-store-name").text();

      $(".booking-calender-slot-wrapper").show();
      setTimeout(function () {
        $('.calendar-day-hover.curr-date').click()
      },10)
      $("body").removeClass("open-confirmation-popup");
      $(".confirmation-popup-wrap").hide();
      $(".store-locator-wrapper").hide();
      $(".booking-progress-wrap.third-step").addClass("active");
      $(".booking-progress-wrap.second-step").removeClass("active");
      $(".booking-progress-wrap.second-step").addClass("active-next-step");

      setCookie("store_name", store_name || null, 1);
      const dayToNumber = {
        Sun: 0,
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
      };

      const filterDayAndTime = (schedule) => {
        return schedule.map((entry) => {
          const [day, ...timeParts] = entry.split(" ");
          const time = timeParts.join(" ");
          const [start, end] = time.split("-");
          console.log({ entry, time, day }, "<<<entry");
          return {
            day: dayToNumber[day],
            start: start?.trim(),
            end: end?.trim(),
          };
        });
      };

      const storeD = window.stores.filter(
        (store) => store.storeName == store_name
      );
      if (storeD?.length) {
        window.times = filterDayAndTime(storeD[storeD.length - 1].openingTime);
        console.log(window.times, "<<<<window.times", storeD);
      }
    } catch (error) {
      console.error("Error fetching store data:", error);
    }
  });



  $(document).on("click", ".calendar-day-hover", function () {
    $(".calendar-day-hover").removeClass("selected");
    $(this).addClass("selected");
    chekLength();
  });

  /**--------------- START:- add date & time for booking  when click on perticular date ----------------**/
  $(".calendar-day-hover.selected").on("click", () => {
    $(".calendar-day-hover").removeClass("selected");
    $(dayElement).addClass("selected");
    console.log("Selected Date jquery:", dayDate.toDateString());
  });

  $(document).on("click", ".time-slot", function () {
    chekLength();
    var booking_time = $(this).text();
    setCookie("booking_time", booking_time || null, 1);
  });

  $(document).on(
    "click",
    ".booking-calender-slot-wrapper .continue--booking-wrap",
    function () {
      console.log(
        "set time:",
        getCookie("booking_time"),
        "date:",
        getCookie("booking_date")
      );

      $(".booking-calender-slot-wrapper").hide();
      $(".form-wrapper").show();
      $(".third-step").removeClass("active").addClass("active-next-step");
      $(".booking-progress-wrap.fourth-step").addClass("active store-service");
    }
  );

  /**--------------- END:- add date & time for bookinh  when click on perticular date ---------------- **/

  $(document).on("change", ".js_deviceType_selector", function () {
    console.log("changed>>", $(this).attr('data-url'));
    window.location.href = $(this).attr('data-url') || $(".third-level-active .nextpagelink").attr("href");
  });

  $(document).on("click", ".btn_label", function () {
    var closest = $(this).closest(".visit_us_popup"),
      active_service = closest.find(".active-service"),
      data_attr = active_service.attr("store-type");

    setCookie("store_type", data_attr || null, 1);
    console.log(
      sel_manufacture__options,
      "<<<<< masel_nufacture__options",
      getCookie("store_type")
    );
    $(".location-btn").attr("store-type", data_attr);
  });

  /**--------------START:-  booking data submit into databse -----------------**/

// $(document).on("click", ".js-appoint-button", async function (e) {
//   e.preventDefault();

//   const main_pro_id = $(".add-product-fields").attr("main-product-id");
//   const main_product = $(".product-title-wrapp .product-title").text();
//   const main_product_price =  $(".product-title-wrapp .repair-product-price").text();
//   let additional_pro_id = null;
//   let additional_pro_name = null;

//   let isValid = true;
//   $(this)
//     .closest("form")
//     .find("[required]")
//     .each(function () {
//       const $field = $(this);
//       const fieldType = $field.prop("type");

//       $field.next(".error").remove();

//       if ($field.val().trim() === "") {
//         $field.focus();
//         isValid = false;
//         return false;
//       } else if (fieldType === "email") {
//         const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailPattern.test($field.val().trim())) {
//           $field.focus();
//           isValid = false;
//           return false;
//         }
//       } else if (fieldType === "tel") {
//         const phonePattern = /^[0-9\-]+$/;
//         if (!phonePattern.test($field.val().trim())) {
//           $field.focus();
//           isValid = false;
//           return false;
//         }
//       }
//     });

//   if (!isValid) {
//     return;
//   }

//   if ($(".add-prod-input").is(":checked")) {
//     additional_pro_id = $(".add-product-fields").attr("additional-product-id");
//     additional_pro_name = $(".addon-product-name").attr("additional-product-name");
//   }

//   const aggre_terms = $(".agreecontent").is(":checked") && $(".termcontent").is(":checked");
//   const formDataJson = getFormDataAsJson("#CustomForm");

//   addSpecificCookiesToFormData(formDataJson, [
//     "booking_date",
//     "booking_time",
//     "store_type",
//     "store_name",
//     "customerterms",
//     "emailmarketing",
//     "Manufacture_Name",
//   ]);

//   formDataJson["manufactureType"] = getCookie("Manufacture_Name");
//   formDataJson["customerTerms"] = aggre_terms;
//   formDataJson["emailMarketing"] = aggre_terms;
//   formDataJson["additionalProductId"] = additional_pro_id;
//   formDataJson["additionalProductName"] = additional_pro_name;
//   formDataJson["repairProductId"] = main_pro_id;
//   formDataJson["repairProduct"] = main_product;
//   formDataJson["repairProductPrice"] = main_product_price;
//   formDataJson["createdDate"] = new Date().toISOString().split("T")[0];

//   function objectToFormData(obj) {
//     const formData = new FormData();
//     for (const [key, value] of Object.entries(obj)) {
//       formData.append(key, value == undefined ? "" : value);
//     }
//     return formData;
//   }

//   const formData = objectToFormData(formDataJson);

//   try {
//     const bookingResponse = await fetch("https://er-magnitude-contributor-runner.trycloudflare.com/api/storeBooking", {
//       method: "POST",
//       body: formData,
//     });

//     if (!bookingResponse.ok) {
//       throw new Error(`Server Error: ${bookingResponse.status}`);
//     }

//     const bookingData = await bookingResponse.json();

//     if (bookingData.success) {
//       $("#CustomForm")[0].reset();
//       $(".booking_success_popup").show();
//     } else {
//       alert("There was an error: " + bookingData.message);
//       return;
//     }
//   } catch (error) {
//     console.error("Error during booking:", error);
//     alert("Failed to book appointment. Please try again.");
//     return;
//   }

 
// });


$(document).on("click", ".js-appoint-button", async function (e) {
  e.preventDefault();

  const button = $(this);
  button.prop("disabled", true).text("Processing..."); // Disable button and show loading state

  $(".error-msg").remove(); 

  const main_pro_id = $(".add-product-fields").attr("main-product-id");
  const main_product = $(".product-title-wrapp .product-title").text();
  const main_product_price = $(".repair-product-price").text();
  let additional_pro_id = null ;
  let additional_pro_name = null ;
  console.log('main_product_price<><><>',main_product_price);
  let isValid = true;

  $(this)
    .closest("form")
    .find("[required]")
    .each(function () {
      const $field = $(this);
      const fieldType = $field.prop("type");
      const fieldName = $field.attr("name");
      const fieldValue = $field.val().trim();

      if (fieldValue === "") {
        isValid = false;
        $field.after('<div class="error-msg" style="color: red; font-size: 14px; margin-top: 5px;">This field is required.</div>');
      } 
      
      // Email Validation
      else if (fieldType === "email") {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(fieldValue)) {
          isValid = false;
          $field.after('<div class="error-msg" style="color: red; font-size: 14px; margin-top: 5px;">Invalid email address.</div>');
        }
      } 
      
      // Phone Number Validation
      else if (fieldType === "tel") {
        const phonePattern = /^[0-9\-]+$/;
        if (!phonePattern.test(fieldValue) || fieldValue.length < 10) {
          isValid = false;
          $field.after('<div class="error-msg" style="color: red; font-size: 14px; margin-top: 5px;">Enter a valid phone number (at least 10 digits).</div>');
        }
      } 
      
      // First Name Validation
      else if (fieldName === "First_Name") {
        const namePattern = /^[A-Za-z\s]+$/;
        if (!namePattern.test(fieldValue) || fieldValue.length < 2) {
          isValid = false;
          $field.after('<div class="error-msg" style="color: red; font-size: 14px; margin-top: 5px;">Enter a valid first name (letters only, at least 2 characters).</div>');
        }
      }
    });

  if (!isValid) {
    button.prop("disabled", false).text("Confirm Appointment"); // Re-enable button
    return;
  }

  if ($(".add-prod-input").is(":checked")) {
    additional_pro_id = $(".add-product-fields").attr("additional-product-id");
    additional_pro_name = $(".addon-product-name").attr("additional-product-name");
  } else {
    additional_pro_id = "Not selected";
    additional_pro_name = "Not selected";
  }

  const aggre_terms = $(".agreecontent").is(":checked") && $(".termcontent").is(":checked");
  const formDataJson = getFormDataAsJson("#CustomForm");

  addSpecificCookiesToFormData(formDataJson, [
    "booking_date",
    "booking_time",
    "store_type",
    "store_name",
    "customerterms",
    "emailmarketing",
    "Manufacture_Name",
  ]);

  formDataJson["manufactureType"] = getCookie("Manufacture_Name");
  formDataJson["customerTerms"] = aggre_terms;
  formDataJson["emailMarketing"] = aggre_terms;
  formDataJson["additionalProductId"] = additional_pro_id;
  formDataJson["additionalProductName"] = additional_pro_name;
  formDataJson["repairProductId"] = main_pro_id;
  formDataJson["repairProduct"] = main_product;
  formDataJson["repairProductPrice"] = main_product_price;
  formDataJson["createdDate"] = new Date().toISOString().split("T")[0];

  function objectToFormData(obj) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      formData.append(key, value == undefined ? "" : value);
    }
    return formData;
  }

  const formData = objectToFormData(formDataJson);

  try {
    const bookingResponse = await fetch("https://book-slot-f052c4d1d372.herokuapp.com/api/storeBooking", {
      method: "POST",
      body: formData,
    });

    if (!bookingResponse.ok) {
      throw new Error(`Server Error: ${bookingResponse.status}`);
    }

    const bookingData = await bookingResponse.json();


    if (bookingData.success) {
      $("#CustomForm")[0].reset();
      $(".booking_success_popup").show();
    } else {
      alert("There was an error: " + bookingData.message);
      return;
    }
  } catch (error) {
    console.error("Error during booking:", error);
    alert("Failed to book appointment. Please try again.");
  } finally {
    button.prop("disabled", false).text("Confirm Appointment"); // Re-enable button after processing
  }
});




  /**--------------END:-  booking data submit into databse -----------------**/

  /**--------------START:-  seller store login for seller page -----------------**/
  $(document).on("click", ".js-store-login", function (e) {
    e.preventDefault();

    const userEmail = $("#email").val();
    const userPassword = $("#password").val();

    if (!userEmail || !userPassword) {
      alert("Please fill in both email and password fields.");
      return;
    }

    const formData = new FormData();
    formData.append("email", userEmail);
    formData.append("password", userPassword);

    fetch("https://slot-booking-74912b360e1a.herokuapp.com/api/authenticate", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.error || `Status: ${response.status}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          document.cookie = `store_name=${data.storeName};path=/;max-age=3600;secure`;

          alert("Login successful! Redirecting to the store details page.");
          console.log("Login successful:", data);
          window.location.href = "/pages/store-details";
        } else {
          console.error("Login failed:", data.error);
          alert("Login failed: " + data.error);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error.message);
        alert("Error: " + error.message);
      });
  });

  /**--------------END:-  seller store login for seller page -----------------**/

  /**----- START:- popup close whenform submit -----**/
  $(document).on("click", ".booking_success_popup .close_popup", function () {
    $(".booking_success_popup").hide();
  });
  /**----- END:- popup close whenform submit -----**/




// START: error message on form
  

  // END:- error message on form
  
}); //end ready

function addSpecificCookiesToFormData(formDataJson, cookieNames) {
  cookieNames.forEach(function (cookieName) {
    var value = getCookie(cookieName);
    if (value) {
      formDataJson[cookieName] = value;
    }
  });
}
function getFormDataAsJson(formSelector) {
  var formDataArray = $(formSelector).serializeArray();
  var formDataJson = {};

  $.map(formDataArray, function (n, i) {
    formDataJson[n["name"]] = n["value"];
  });

  return formDataJson;
}
function chekLength() {
  var calendarLength = $(".calendar-day-hover.selected").length,
    timeLength = $(".time-slot.selected").length;
  if (calendarLength > 0 && timeLength > 0) {
    $(".continue--booking-wrap").removeClass("disabled");
  } else {
    $(".continue--booking-wrap").addClass("disabled");
  }
}
function aggrement() {
  if ($(".termcontent").is(":checked")) {
    $(".js-appoint-button").removeClass("disabled");
    $(".error-msg").hide();
    var term_accept = true;
  } else {
    $(".js-appoint-button").addClass("disabled");
    $(".error-msg").show();
    var term_accept = false;
  }
}
function validateEmail(email) {
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function getPincode(lat, lng) {
  var geocoder = new google.maps.Geocoder();
  var latlng = { lat: lat, lng: lng };

  geocoder.geocode({ location: latlng }, function (results, status) {
    if (status === "OK") {
      if (results[0]) {
        var addressComponents = results[0].address_components;
        for (var i = 0; i < addressComponents.length; i++) {
          var component = addressComponents[i];
          if (component.types.includes("postal_code")) {
            var pincode = component.long_name;
            console.log("Pincode:", pincode);
            fetchStores(pincode, latlng);
            break;
          }
        }
      } else {
        console.log("No results found");
      }
    } else {
      console.error("Geocoder failed due to: " + status);
    }
  });
}

/**----------- START:- fetch store for perticular pincode and get all stroes from database ----------**/
async function fetchStores(pintext, origin) {
  try {
    $(".store-name_main-wrapper").remove();
    $(".pintext").remove();

    const response = await fetch(
      "https://slot-booking-74912b360e1a.herokuapp.com/api/stores",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    console.log(result, "result");

    window.stores = result.data;
    if (result?.status) {
      let storesWithDistance = [];

      // First, calculate the distance for each store
      for (const item of result.data) {
        const toLat = parseFloat(item.latitude);
        const toLon = parseFloat(item.longitude);

        let distance = null;

        if (!isNaN(toLat) && !isNaN(toLon)) {
          distance = calculateDistance(origin.lat, origin.lng, toLat, toLon);
        }

        storesWithDistance.push({
          store: item,
          distance: distance,
        });
      }

      // Sort stores by distance
      storesWithDistance.sort((a, b) => {
        if (a.distance === null) return 1;
        if (b.distance === null) return -1;
        return a.distance - b.distance;
      });

      // Now, display the stores in sorted order
      for (const storeItem of storesWithDistance) {
        const item = storeItem.store;
        const distance = storeItem.distance;

        const storeWrapper = $(`
          <div class="store-name_main-wrapper">
            <div class="store-name-container">
              <div class="item-store_name-wrap">
                <div class="store__diistance_wrapp"></div>
                <div class="store-name">
                  <h3 class="main-store-name">${item.storeName}</h3>
                </div>
                <div class="pintext">Appointments available</div>
                <div class="store-image-wrap"></div>
              </div>
              <button class="select-btn-wrap">Select</button>
            </div>
            <div class="opening-time-wrap">
              <div class="view-details-wrap">View Store Details</div>
              <div class="opening-addres-wrap" style="display:none;">
                <div class="address">
                  <h5>Address</h5>
                  ${item.address ? item.address : ""}
                </div>
                <div class="distance-wrap" style="margin-top: 10px;">
                  <h5>Distance: <span class="distance">Calculating...</span></h5>
                </div>
              </div>
            </div>
          </div>
        `);

        item.images.forEach((image) => {
          if (image) {
            storeWrapper
              .find(".store-image-wrap")
              .append(`<img src="${image}" height="100" width="100"/>`);
          }
        });

        item.openingTime.forEach((timing) => {
          if (timing) {
            storeWrapper
              .find(".opening-time-wrap")
              .append(`<div class="timing">${timing}</div>`);
          }
        });

        $(".locator-search-wrapper").append(storeWrapper);

        if (distance !== null) {
          storeWrapper
            .find(".store__diistance_wrapp")
            .text(`${distance.toFixed(2)} km`);
        } else {
          storeWrapper.find(".store__diistance_wrapp").text("No distance data");
        }
      }
    } else {
      console.error("Invalid response structure or data format");
    }
  } catch (error) {
    console.error("Error fetching stores:", error);
  }
}
/**----------- END:- fetch store for perticular pincode and get all stroes from database ----------**/

/**----------- START:- fetch store distance for perticular pincode  from database ----------**/
function calculateDistance(fromLat, fromLon, toLat, toLon) {
  const R = 6371; // Earth's radius in kilometers
  const toRadians = (deg) => (deg * Math.PI) / 180;

  const dLat = toRadians(toLat - fromLat);
  const dLon = toRadians(toLon - fromLon);

  const lat1 = toRadians(fromLat);
  const lat2 = toRadians(toLat);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in kilometers
}
/**----------- END:- fetch store distance for perticular pincode  from database ----------**/

/**----------- START:- for getting pincode co-ordinates when pincode entered ----------**/
function getPincode(lat, lng) {
  return new Promise((resolve, reject) => {
    $.get(
      "https://maps.googleapis.com/maps/api/geocode/json",
      {
        latlng: `${lat},${lng}`,
        key: "AIzaSyBUmYZ5zC4r5Z63E883a4AMKXyrTZicgEE",
      },
      function (data) {
        if (data.status === "OK") {
          for (let i = 0; i < data.results.length; i++) {
            for (
              let j = 0;
              j < data.results[i].address_components.length;
              j++
            ) {
              let component = data.results[i].address_components[j];
              if (component.types.includes("postal_code")) {
                resolve(component.long_name);
                return;
              }
            }
          }
          reject("Pincode not found");
        } else {
          reject("Geocode failed");
        }
      }
    );
  });
}
/**----------- END:- for getting pincode co-ordinates when pincode entered ----------**/

/* START::timeslots */

const timeSlots = [
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
];
const timeSlotsContainer = document.getElementById("timeSlots");
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const currentDate = new Date();
let currentYear = currentDate.getFullYear();
let currentMonth = currentDate.getMonth();
const monthPicker = document.getElementById("month-picker");

// function populateTimeSlots(timeSlotsss = timeSlots) {
//   try {
//     timeSlotsContainer.innerHTML = "";
//     timeSlotsss.forEach((slot) => {
//       const slotElement = document.createElement("div");
//       slotElement.classList.add("time-slot");
//       slotElement.innerText = slot;

//       slotElement.addEventListener("click", () => {
//         document
//           .querySelectorAll(".time-slot")
//           .forEach((el) => el.classList.remove("selected"));
//         slotElement.classList.add("selected");
//       });

//       timeSlotsContainer.appendChild(slotElement);
//     });
//   } catch (error) {}
// }

function populateTimeSlots(timeSlotsss = timeSlots, selectedDate = new Date()) {
  try {
    timeSlotsContainer.innerHTML = "";

    const now = new Date();
    const isToday =
      now.toDateString() === new Date(selectedDate).toDateString(); // Check if selected date is today
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();

    timeSlotsss.forEach((slot) => {
      const [hours, minutes] = slot.split(":").map(Number);

      const slotElement = document.createElement("div");
      slotElement.classList.add("time-slot");
      slotElement.innerText = slot;

      // Disable only past time slots if the selected date is today
      if (isToday && (hours < currentHours || (hours === currentHours && minutes < currentMinutes))) {
        slotElement.classList.add("disabled");
      } else {
        slotElement.addEventListener("click", () => {
          document
            .querySelectorAll(".time-slot")
            .forEach((el) => el.classList.remove("selected"));
          slotElement.classList.add("selected");
        });
      }

      timeSlotsContainer.appendChild(slotElement);
    });
  } catch (error) {
    console.error(error);
  }
}
populateTimeSlots();

const isLeapYear = (year) =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
const getFebDays = (year) => (isLeapYear(year) ? 29 : 28);

function generateCalendar(month, year) {
  const calendarDays = document.querySelector(".calendar-days");
  const yearDisplay = document.getElementById("year");
  const daysOfMonth = [
    31,
    getFebDays(year),
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  calendarDays.innerHTML = "";
  monthPicker.innerText = monthNames[month];
  yearDisplay.innerText = year;

  const firstDay = new Date(year, month, 1).getDay();
  const today = new Date();

  for (let i = 0; i < daysOfMonth[month] + firstDay; i++) {
    const dayElement = document.createElement("div");

    if (i >= firstDay) {
      const day = i - firstDay + 1;
      const dayDate = new Date(year, month, day);

      dayElement.classList.add("calendar-day-hover");
      dayElement.innerText = day;

      if (dayDate.toDateString() === today.toDateString()) {
        dayElement.classList.add("curr-date");
      }

      if (dayDate < today && dayDate.toDateString() !== today.toDateString()) {
        dayElement.classList.add("disabled");
        dayElement.style.pointerEvents = "none";
        dayElement.style.color = "#ccc";
      } else {
        dayElement.addEventListener("click", () => {
          document
            .querySelectorAll(".calendar-day-hover")
            .forEach((el) => el.classList.remove("selected"));
          dayElement.classList.add("selected");
          const booking_date = dayDate.toDateString();
          setCookie("booking_date", booking_date || null, 1);
          console.log(
            "Selected Date:",
            dayDate.toDateString(),
            dayDate.getDay()
          );

          const time_slots = window.times?.filter(
            (time) => time.day == dayDate.getDay()
          );
          const tarry = generateTimeArray(
            time_slots[0]?.start,
            time_slots[0]?.end
          );
          populateTimeSlots(tarry, dayDate);
          console.log({
            t: window.times,
            d: dayDate.getDay(),
            time_slots,
            tarry,
          });
        });
      }
    }

    calendarDays.appendChild(dayElement);
  }
}

const generateTimeArray = (start, end) => {
  console.log({ start, end });
  start = start.replace(".", ":");
  end = end.replace(".", ":");

  const times = [];
  let currentTime = new Date(`1970-01-01T${start}:00`);
  const endTime = new Date(`1970-01-01T${end}:00`);

  while (currentTime <= endTime) {
    times.push(currentTime.toTimeString().slice(0, 5)); // Format as HH:MM
    currentTime = new Date(currentTime.getTime() + 30 * 60000); // Add 30 minutes
  }
  return times;
};

function updateYearNavigation() {
  const prevYearButton = document.getElementById("prev-year");
  if (currentYear <= currentDate.getFullYear()) {
    prevYearButton.classList.add("disabled");
  } else {
    prevYearButton.classList.remove("disabled");
  }
}

function showMonthList() {
  const monthList = document.getElementById("month-list");
  monthList.innerHTML = ""; // Clear the list
  monthNames.forEach((month, index) => {
    const monthElement = document.createElement("div");
    monthElement.innerText = month;
    monthElement.classList.add("month-item");
    monthElement.addEventListener("click", () => {
      currentMonth = index;
      monthPicker.innerText = month;
      monthList.classList.remove("show");
      generateCalendar(currentMonth, currentYear);
    });
    monthList.appendChild(monthElement);
  });
  monthList.classList.add("show");
}

document.getElementById("prev-year") && document.getElementById("prev-year").addEventListener("click", () => {
  if (currentYear > currentDate.getFullYear()) {
    currentYear--;
    generateCalendar(currentMonth, currentYear);
    updateYearNavigation();
  }
});

document.getElementById("next-year").addEventListener("click", () => {
  currentYear++;
  generateCalendar(currentMonth, currentYear);
  updateYearNavigation();
});

monthPicker.addEventListener("click", (e) => {
  e.stopPropagation(); // Prevent click event from propagating to body
  showMonthList();
});

document.body.addEventListener("click", () => {
  const monthList = document.getElementById("month-list");
  if (monthList.classList.contains("show")) {
    monthList.classList.remove("show");
  }
});

generateCalendar(currentMonth, currentYear);
updateYearNavigation();
/* END:: tmimesots */
